import { SET_CLIENT_REPORT } from "../actions/action-types.js";

export default function clientReport(state = {}, {type, payload}) {
    switch (type) {
        case SET_CLIENT_REPORT:
            return (state = payload)
        default:
            return state
    }
}